// extracted by mini-css-extract-plugin
module.exports = {"visualitzacioSelectorPeriode":"VisualitzacioSelectorPeriode_visualitzacioSelectorPeriode__gA7C2","selector":"VisualitzacioSelectorPeriode_selector__3qYMN"};